export default __webpack_public_path__ + "static/media/straubing-zoo-logo.92250332.png";